export default "__VITE_ASSET__75bc3dd9__"